module.exports = __webpack_public_path__ + "img/logo.6f9876f4.svg";